export const GEMINI_API = {
  apiKey: process.env.REACT_APP_GEMINI_API_KEY || '',
  model: 'gemini-2.5-flash-image-preview'
};

export const IMAGE_GENERATION_CONFIG = {
  maxImages: 4,
  defaultPromptPrefix: 'Generate a high-quality, realistic sticker',
  timeout: 30000
};